
export const SUMMER_OFF_BOARDING_END_DATE = '2023-12-18';
